import type { TournamentRoundsApi } from '@/v2/api/metadata/tournament-rounds'
import {
  addFeedMappingRow,
  buildFeedMappingGrid,
  createFeedMappingSubmitGate,
  fetchFeedTypeMappingsList,
} from '@/v2/kits/feed-mapping'
import type { GridTab, GridTabSaveContext } from '@/v2/framework/dialog/types'
import { notifySuccess, tournamentRoundId } from '../shared'

export function createFeedMappingTab(roundsApi: TournamentRoundsApi): GridTab {
  async function save(ctx: GridTabSaveContext): Promise<void> {
    const gate = ctx.gate
    if (!gate?.hasSuccessfulLoad() || !gate.isDirty()) return
    if (!gate.validateForDialogSubmit()) {
      throw new Error('Please fill the required fields')
    }

    const fragment = gate.buildMergeFragment()
    if (!fragment) return

    const entityId = tournamentRoundId(ctx.values)
    await roundsApi.update(entityId, fragment)

    if (!ctx.rows) {
      throw new Error('Feed mapping grid is not available')
    }

    ctx.rows.value = await fetchFeedTypeMappingsList(roundsApi.getFeedTypeMappings, entityId, {
      isReadAfterWrite: true,
    })
    gate.markClean?.()
    notifySuccess()
  }

  return {
    kind: 'grid',
    id: 'feed-mapping',
    label: 'Feed mapping',
    createGrid: (getValues) =>
      buildFeedMappingGrid(
        () => tournamentRoundId(getValues()),
        roundsApi.getFeedTypeMappings.bind(roundsApi),
      ),
    createSubmitGate: createFeedMappingSubmitGate,
    save,
    addRowLabel: 'common.buttons.add_new',
    onAddRow: addFeedMappingRow,
  }
}
